export class Model{

	protected primaryKey:string

	fill(data:{[key:string]:any}){
	}

	getKey():number{
		return 111
	}

}
